// const filteredProductsBtns = document.querySelectorAll('.filteredProductsLoop__button');
// const productLists = document.querySelectorAll('.filteredProductsLoop ul');

// if (filteredProductsBtns && productLists) {
//     const toggleNoFoundMessage = (list, show) => {
//         const noFoundMessage = list.querySelector('.noFound');
//         if (noFoundMessage) {
//             noFoundMessage.classList.toggle('hidden', !show);
//         }
//     };

//     const updateListVisibility = (activeFilter) => {
//         productLists.forEach((list) => {
//             const listFilter = list.getAttribute('data-products-filter');
//             const shouldShow =
//                 activeFilter === 'all' ? listFilter === 'all' : listFilter === activeFilter;

//             list.classList.toggle('grid', shouldShow);
//             list.classList.toggle('hidden', !shouldShow);

//             const isEmpty = shouldShow && list.querySelectorAll('li').length === 0;
//             toggleNoFoundMessage(list, isEmpty);
//         });
//     };

//     filteredProductsBtns.forEach((button) => {
//         button.addEventListener('click', function () {
//             filteredProductsBtns.forEach((btn) =>
//                 btn.classList.remove('filteredProductsLoop__button--active'),
//             );
//             this.classList.add('filteredProductsLoop__button--active');

//             const activeFilter = this.getAttribute('data-product-filter');
//             updateListVisibility(activeFilter);
//         });
//     });

//     // Initialize with 'all' filter active
//     updateListVisibility('all');
// }
